import React, { useState } from "react";
import "../../pages/doctor-console/DoctorConsole.scss";
import {
  Modal,
  Box,
  Typography,
  Button as muiButton,
  IconButton,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close"; // Import the close icon
import { Row, Col } from "../../components/RowCol";
import { Table, Button } from "react-bootstrap";
import { Icon, TableHead } from "@mui/material";
import HiTypeHeader from "../../pages/doctor-console/Utils/HiTypeHeader";
import { separateCamelCase } from "../../pages/doctor-console/Utils/UtilsFunctions";
import { DoctorconsoleGrid } from "../../pages/doctor-console/StyledComponents";
import { AttachmentActionButtons, ModalActionButtons } from "../../pages/doctor-console/Utils/AttachmentActions";

function ReportingChart(props) {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [currentAttachment, setCurrentAttachment] = useState(null);
  const diagnosticData = props.diagnosticData;
  console.log("DiagnosticData", diagnosticData);
  const viewAttachment = (attach) => {
    // console.log(attachment);
    let attachment = attach.content[0];
    setCurrentAttachment(attachment);
    // Wrap the content in a div with overflow for scrollability
    let modalContent;
    if (attachment.content_type === "application/pdf") {
      const url = `data:application/pdf;base64,${attachment.data}#toolbar=0`;
      modalContent = (
        <iframe width="100%" height="100%" src={url} title={attach.id}></iframe>
      );
    } else if (
      attachment.content_type === "image/jpeg" ||
      attachment.content_type === "image/jpg" ||
      attachment.content_type === "image/png"
    ) {
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      // Display image files
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "80%",
            maxHeight: "700px",
          }}
        >
          <img src={url} alt={attach.id} title={attach.id} />
        </div>
      );
    } else {
      // Default to displaying it as an image if content type is unknown
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    }

    setModalContent(modalContent);
    setShowModal(true);
  };
  const viewAttachmentMedia = (attach) => {
    // console.log(attachment);
    let videoRef = null; // Reference to the video element

    // Function to toggle video play/pause
    const toggleVideoPlayPause = () => {
      if (videoRef) {
        if (videoRef.paused) {
          videoRef.play();
        } else {
          videoRef.pause();
        }
      }
    };
    let attachment = attach;
    setCurrentAttachment({ data: attachment.content_data, content_type: attachment.content_type });
    console.log("Content Type ", attachment.content_type);
    // Wrap the content in a div with overflow for scrollability
    let modalContent;
    if (attachment.content_type === "application/pdf") {
      const url = `data:application/pdf;base64,${attachment.content_data}#toolbar=0`;
      modalContent = (
        <iframe width="100%" height="100%" src={url} title={attach.id}></iframe>
      );
    } else if (
      attachment.content_type === "image/jpeg" ||
      attachment.content_type === "image/jpg" ||
      attachment.content_type === "image/png"
    ) {
      const url = `data:${attachment.content_type};base64,${attachment.content_data}`;
      // Display image files
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "80%",
            maxHeight: "700px",
          }}
        >
          <img src={url} alt={attach.id} title={attach.id} />
        </div>
      );
    } else if (
      attachment.content_type === "video/mov" ||
      attachment.content_type === "video/rm" ||
      attachment.content_type === "video/mpg" ||
      attachment.content_type === "video/avi" ||
      attachment.content_type === "video/mp4" ||
      attachment.content_type === "video/quicktime"
    ) {
      var byteCharacters = atob(attachment?.content_data);
      var byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], { type: attachment?.content_type });

      const url = window.URL.createObjectURL(blob);
      console.log("Video url", url);
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <video
            ref={(ref) => (videoRef = ref)} // Set the video element reference
            width="100%"
            height="100%"
            controls
            autoPlay
            onClick={toggleVideoPlayPause} // Add click event to toggle play/pause
          >
            <source src={url} />
          </video>
        </div>
      );
    } else {
      // Default to displaying it as an image if content type is unknown
      const url = `data:${attachment.content_type};base64,${attachment.content_data}`;
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    }

    setModalContent(modalContent);
    setShowModal(true);
  };
  const formatDate = (visitDatetime) => {
    const formattedDate = new Date(visitDatetime);

    const day = String(formattedDate.getDate()).padStart(2, "0");
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = String(formattedDate.getFullYear()).slice(-2); // Extract the last two digits of the year

    let hours = formattedDate.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight
    const minutes = String(formattedDate.getMinutes()).padStart(2, "0");

    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;

    console.log(formattedDateTime);
    return formattedDateTime;
  };
  const closeModal = () => {
    setShowModal(false);
    setModalContent(null);
    setCurrentAttachment(null);
  };

  // console.log(state);
  return (
    <>
      <DoctorconsoleGrid>
        {diagnosticData !== undefined && diagnosticData !== null ? (
          <>
            <HiTypeHeader
              date={diagnosticData.Date}
              name={"Diagnostic Record"}
              encounter={diagnosticData.Encounter}
              organizationDetails={diagnosticData.Organization}
              practitionerDetails={diagnosticData.Practitioner}
            />
            {Object.keys(diagnosticData).map(
              (categoryKey) =>
                ![
                  "Encounter",
                  "Date",
                  "Organization",
                  "Practitioner",
                  "Patient",
                  "Observation",
                ].some(
                  (substring) =>
                    substring === categoryKey.match(/\(([^)]+)\)/)?.[1] ||
                    substring == categoryKey // Extract and check in the same line
                ) &&
                !categoryKey.includes("Observation") && (
                  <Accordion className="innermost-accordion" defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      className="innermost-accordion-summary"
                    >
                      <Typography
                        sx={{ color: "white" }}
                        className="accordion-section-title"
                      >
                        {categoryKey}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Row
                        style={{
                          marginTop: "30px",
                          // backgroundImage:
                          //   "url('../../assets/images/backgrounds/2.jpg')",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      >
                        <Col
                          area="span 12"
                          style={{ border: "2px solid #76787a" }}
                        >
                          {categoryKey.includes("DocumentReference") ? (
                            <div
                              style={{
                                marginTop: "20px",
                                fontWeight: "bold",
                                marginBottom: "50px",
                                fontSize: "16px",
                              }}
                            >
                              <div style={{ marginRight: "10px" }}>
                                Attachments :{" "}
                              </div>

                              {diagnosticData[categoryKey].length > 0
                                ? diagnosticData[categoryKey].map(
                                    (attachment, attIdx) => (
                                      <span key={attIdx} style={{ display: "inline-flex", alignItems: "center", gap: "4px", marginRight: "12px" }}>
                                        <button
                                          style={{
                                            margin: "10px",
                                            backgroundColor: "#007bff",
                                            color: "#fff",
                                            border: "none",
                                            padding: "5px 10px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            viewAttachment(attachment)
                                          }
                                        >
                                          {" "}
                                          {/* Click here to see{" "} */}
                                          <i className="fas fa-file"></i>
                                        </button>
                                        <AttachmentActionButtons base64Data={attachment?.content?.[0]?.data} contentType={attachment?.content?.[0]?.content_type} filename={attachment?.id || "attachment"} />
                                      </span>
                                    )
                                  )
                                : "No attachments found!"}
                            </div>
                          ) : categoryKey.includes("Media") ? (
                            <div
                              style={{
                                marginTop: "20px",
                                fontWeight: "bold",
                                marginBottom: "50px",
                                fontSize: "16px",
                              }}
                            >
                              <div style={{ marginRight: "10px" }}>
                                Media Documents :{" "}
                              </div>

                              {diagnosticData[categoryKey].length > 0
                                ? diagnosticData[categoryKey].map(
                                    (attachment, attIdx) => (
                                      <span key={attIdx} style={{ display: "inline-flex", alignItems: "center", gap: "4px", marginRight: "12px" }}>
                                        <button
                                          style={{
                                            margin: "10px",
                                            backgroundColor: "#007bff",
                                            color: "#fff",
                                            border: "none",
                                            padding: "5px 10px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            viewAttachmentMedia(attachment)
                                          }
                                        >
                                          {" "}
                                          {/* Click here to see{" "} */}
                                          <i className="fas fa-file"></i>
                                        </button>
                                        <AttachmentActionButtons base64Data={attachment?.content_data} contentType={attachment?.content_type} filename="media-attachment" />
                                      </span>
                                    )
                                  )
                                : "No attachments found!"}
                            </div>
                          ) : categoryKey.includes("DiagnosticReport") ? (
                            <div>
                              {diagnosticData[categoryKey].map(
                                (report, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      marginTop: "20px",
                                      fontWeight: "bold",
                                      marginBottom: "50px",
                                      fontSize: "16px",
                                    }}
                                  >
                                    <p style={{ textAlign: "center" }}>
                                      {typeof report?.code?.[0] === "object" &&
                                      report?.code?.[0] !== null
                                        ? report.code[0].display || "NA"
                                        : report?.code?.[0] ??
                                          "Panel Name not available!"}
                                    </p>

                                    {report?.results?.length > 0 ? (
                                      <Table
                                        responsive
                                        size="lg"
                                        style={{ margin: "20px 7px" }}
                                      >
                                        <TableHead
                                          style={{
                                            textAlign: "center",
                                            verticalAlign: "middle",
                                            gridTemplateColumns:
                                              "250px 250px 250px 120px 120px",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <>
                                            <td
                                              style={{ fontWeight: "normal" }}
                                            >
                                              Name
                                            </td>
                                            <td
                                              style={{ fontWeight: "normal" }}
                                            >
                                              Value Quantity
                                            </td>
                                            <td
                                              style={{ fontWeight: "normal" }}
                                            >
                                              Reference Range
                                            </td>
                                            <td
                                              style={{ fontWeight: "normal" }}
                                            >
                                              Status
                                            </td>
                                          </>
                                        </TableHead>
                                        <tbody style={{ fontWeight: "normal" }}>
                                          {report.results.map(
                                            (result, index) => (
                                              <tr key={index}>
                                                <td>
                                                  {result?.code &&
                                                  result.code.length > 0
                                                    ? result.code[
                                                        result.code.length - 1
                                                      ].text ||
                                                      result.code[
                                                        result.code.length - 1
                                                      ].display ||
                                                      "-"
                                                    : "-"}
                                                </td>
                                                {/* Render value_quantity details */}
                                                <td>
                                                  {result?.value_quantity ? (
                                                    <ul>
                                                      {Object.entries(
                                                        result.value_quantity
                                                      ).map(
                                                        ([key, value]) =>
                                                          key !== "code" && (
                                                            <li key={key}>
                                                              <strong>
                                                                {key}:
                                                              </strong>{" "}
                                                              {value}
                                                            </li>
                                                          )
                                                      )}
                                                    </ul>
                                                  ) : (
                                                    "-"
                                                  )}
                                                </td>
                                                <td>
                                                  <ul>
                                                    <li>
                                                      <strong>High-</strong>{" "}
                                                      Unit:{" "}
                                                      {result
                                                        ?.reference_range?.[0]
                                                        ?.high?.unit ?? "-"}
                                                      , Value:{" "}
                                                      {result
                                                        ?.reference_range?.[0]
                                                        ?.high?.value ?? "-"}
                                                    </li>
                                                    <li>
                                                      <strong>Low-</strong>{" "}
                                                      Unit:{" "}
                                                      {result
                                                        ?.reference_range?.[1]
                                                        ?.low?.unit ?? "-"}
                                                      , Value:{" "}
                                                      {result
                                                        ?.reference_range?.[1]
                                                        ?.low?.value ?? "-"}
                                                    </li>
                                                  </ul>
                                                </td>

                                                {/* Render Status */}
                                                <td>{result?.status ?? "-"}</td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </Table>
                                    ) : (
                                      <p>No results found!</p>
                                    )}
                                  </div>
                                )
                              )}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                    </AccordionDetails>
                  </Accordion>
                )
            )}
          </>
        ) : (
          <div
            style={{
              marginTop: "20px",
              padding: "10px",
              backgroundColor: "#3AC8BA",
              fontWeight: "bold",
              fontSize: "25px",
            }}
          >
            No Discharge Summary found!
          </div>
        )}
      </DoctorconsoleGrid>

      <Modal open={showModal} onClose={closeModal}>
        <Box className="modal-box">
          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "4px", padding: "8px 12px", borderBottom: "1px solid #e0e0e0" }}>
            {currentAttachment && (
              <ModalActionButtons base64Data={currentAttachment.data || currentAttachment.content_data} contentType={currentAttachment.content_type} filename="attachment" />
            )}
            <IconButton onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </div>
          {/* <Typography variant="h6">PDF Viewer</Typography> */}

          <div style={{ flex: 1 }}>{modalContent}</div>
        </Box>
      </Modal>
    </>
  );
}

export default ReportingChart;
